import { render, staticRenderFns } from "./cowsBelow18Months.vue?vue&type=template&id=e1b33ba8&scoped=true&"
import script from "./cowsBelow18Months.vue?vue&type=script&lang=js&"
export * from "./cowsBelow18Months.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b33ba8",
  null
  
)

export default component.exports